module.exports = __webpack_public_path__ + "static/img/img01.b247f4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductsCenter/img/img01.jpg
// module id = JFKk
// module chunks = 1